export const getElementMarkdown = (element, generation = false) => {
  let string = "";
  switch (element.type) {
    case "link":
      string = `[${element.value.name}](${element.value.url})`;
      break;
    case "image":
      string = `![${element.value.name}](${element.value.url})`;
      break;
    case "badge":
      string = `[![${element.value.name}](${element.image})](${element.value.url})`;
      break;
    case "codeblock":
      string = `${element.code}\n${element.value} \n${element.code}`;
      break;
    case "code":
      string = `${element.code} ${element.value} ${element.code}`;
      break;
    case "list":
      element.value.forEach((v) => {
        string += `${v.prefix == "" ? "\n" : ""} ${indentString(
          v.prefix,
          v.indent,
          generation ? " " : "\t"
        )} ${v.value}${v.prefix == "" ? "\n" : ""}\n`;
      });
      break;
    default:
      string = `${element.code} ${element.value ? element.value : ""}`;
      break;
  }
  return string;
};
export const trimString = (data) => {
  if (typeof data == "string") return data.replace(/^\s+|\s+$/g, "");
  else return data;
};

export const indentString = (string, count = 0, indent = " ") =>
  string.replace(/^/gm, indent.repeat(count));

export const replaceAll = (string, newCharacter, character = " ") =>
  string.replaceAll(character, newCharacter);
